export const DEFAULTS_VERSION = 1;

export const DEFAULT_SECTIONS = Object.freeze( [
	'cloud',
	'atmosphere',
	'temporal',
	'cloudShadows',
	'adaptive',
	'resources'
] );

function isRecord( value ) {

	return value !== null && typeof value === 'object' && ! Array.isArray( value );

}

export function createDefaultsSnapshot( state ) {

	return normalizeDefaults( {
		version: DEFAULTS_VERSION,
		cloud: { ...state.cloud },
		atmosphere: { ...state.atmosphere },
		temporal: { ...state.temporal },
		cloudShadows: { ...state.cloudShadows },
		adaptive: { ...state.adaptive },
		resources: { ...state.resources }
	} );

}

export function normalizeDefaults( value ) {

	if ( ! isRecord( value ) || value.version !== DEFAULTS_VERSION ) {

		throw new TypeError( `Defaults must use schema version ${ DEFAULTS_VERSION }.` );

	}

	const normalized = { version: DEFAULTS_VERSION };
	for ( const section of DEFAULT_SECTIONS ) {

		if ( value[ section ] === undefined ) continue;
		if ( ! isRecord( value[ section ] ) ) throw new TypeError( `Defaults section "${ section }" must be an object.` );
		normalized[ section ] = { ...value[ section ] };

	}

	return normalized;

}

export function mergeDefaultSections( projectDefaults, browserDefaults, section ) {

	return {
		...( projectDefaults?.[ section ] ?? {} ),
		...( browserDefaults?.[ section ] ?? {} )
	};

}
